import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiAgent from "../../api/apiAgent";
import { getDataAndSchemaFromModel } from "../../components/Forms/Inputs/utils";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel } from "../../atoms";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import UsersForm from "./form";

const UpdateUser = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams();
  const [originFrom, originId] = useOriginParams();
  const modelData = useAtomValue(modelDataAtom);
  const modelName = "users";
  useValidateModel(modelName);

  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);
  const [isLoadingSchema, setIsLoadingSchema] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoadingSchema) {
      const [, getSchema] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true,
      );

      getSchema.push({ name: "confirmPassword", type: "string" });

      // we don't set item data for update
      setSchema(getSchema);
      setIsLoadingSchema(false);
    }
  }, [modelData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // TODO: Add this back if you need (admin) users creating users
      const response = await apiAgent.Users.getAll(modelName);
      const { data } = response;
      const item =
        data.find((item: any) => _.toString(item.id) === params.id) || null;
      setItemData({ ...item, password: "", confirmPassword: "" });
    } catch (err: any) {
      if (err.response?.status === 401)
        tMsg.info(
          "You may only view/modify users within 15 minutes of logging in",
        );
    } finally {
      setIsLoadingData(false);
    }
  };

  const saveItem = async () => {
    if (
      itemData.password &&
      itemData.password.length > 0 &&
      itemData.password !== itemData.confirmPassword
    ) {
      tMsg.error("Passwords do not match");
      return;
    }

    try {
      // TODO: Add this back if you need (admin) users creating users
      console.log("Saving", itemData);
      const response = await apiAgent.Users.update(modelName, {
        ...itemData,
        target_idx: itemData.id,
      });
      if (response.status === 200) {
        tMsg.success(`Successfully updated`);
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}`);
        else navigate(`/m/${modelName}`);
      } else throw response.statusText;
    } catch (err: any) {
      if (err.response?.status === 401)
        tMsg.info("You may only view/modify users within 15s of logging in");
      else tMsg.error(`Error changing ${modelName}`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: checkTitle(modelName),
      link: `/m/${modelName}`,
    },
  ];

  return (
    <PageContainer
      isLoading={isLoadingData || isLoadingSchema}
      className="relative"
    >
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Edit ${checkTitle(modelName)}`}>
          <BackButton />
        </TitleBar>
        <UsersForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          customModel={"updateUser"}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem();
          }}
        />
      </PageContent>
      <PageFooterBar>
        <SaveButton onClick={() => saveItem()} />
      </PageFooterBar>
    </PageContainer>
  );
};

export default UpdateUser;
